// extracted by mini-css-extract-plugin
export default {"gift-icon":"_3fNlJ","giftIcon":"_3fNlJ","wiggle":"_25Z3J"};